import React, { useCallback, useEffect, useRef, useState } from "react";

import {
  Button,
  DatePicker,
  Dropdown,
  Form,
  message,
  Modal,
  Select,
  Space,
  Table,
  Tabs,
  Tag,
  Tooltip,
  Typography,
} from "antd";
import moment from "moment";

import {
  CopyOutlined,
  DownloadOutlined,
  DownOutlined,
  FilterOutlined,
  InfoCircleOutlined,
  MoreOutlined,
  ReloadOutlined,
} from "@ant-design/icons";

import CustomSearchbar from "../../Components/CustomSearchbar/CustomSearchbar";
import FiltersWrapper from "../../Components/FiltersWrapper/FiltersWrapper";
import {
  exportPlanChangeTransactionsCsv,
  exportPriceBlockTransactionsCsv,
  fetchPlanChangeTransactions,
  fetchPriceBlockTransactions,
} from "../api";

const { Text } = Typography;

// const dummyTransactionsData = [
//   {
//     key: "1",
//     orderId: "ORD-99281",
//     date: "2026-04-01T16:00:00",
//     creatorName: "John Doe",
//     contact: "+91 98765 43210",
//     email: "john@example.com",
//     saleName: "Summer Bonanza",
//     coupon: "SUMMER25",
//     previousSetup: "Freedom",
//     previousTier: "Basic",
//     currentSetup: "Enterprise",
//     currentTier: "Pro",
//     oneTimeFee: 100000,
//     subscriptionFee: 25000,
//     discount: 10,
//     validity: 12,
//     paymentPlan: "One-Time",
//     status: "Paid",
//     daysLeft: 45,
//     pgCharges: 2500,
//     pgChargesGst: "incl",
//     tanNumber: "ABCD12345E",
//     gstNumber: "29ABCDE1234F1Z5",
//     noCostEmiCharges: 0,
//     affiliateName: "Rahul Kumar",
//     affiliateHost: "rahulmarketing.com",
//     affiliateLink: "https://rahulmarketing.com/ref/summer",
//     affiliateContact: "+91 99887 76655",
//     revenueShare: 15,
//     commissionEarned: 15000,
//     targetedCustomer: "Yes",
//     utmParameters: [
//       { key: "utm_source", value: "google" },
//       { key: "utm_medium", value: "cpc" },
//     ],
//   },
//   {
//     key: "2",
//     orderId: "ORD-99282",
//     date: "2026-04-02T19:45:00",
//     creatorName: "Jane Smith",
//     contact: "+91 87654 32109",
//     email: "jane@example.com",
//     saleName: "Flash Sale",
//     coupon: "FLASH15",
//     previousSetup: "Free",
//     previousTier: "N/A",
//     currentSetup: "Freedom",
//     currentTier: "Advanced",
//     oneTimeFee: 50000,
//     subscriptionFee: 25000,
//     discount: 15,
//     validity: 6,
//     paymentPlan: "PartialPay",
//     status: "Due",
//     daysLeft: 30,
//     pgCharges: 1500,
//     pgChargesGst: "excl",
//     tanNumber: "",
//     gstNumber: "27XYZAB5678C2D6",
//     noCostEmiCharges: 500,
//     affiliateName: "",
//     affiliateHost: "",
//     affiliateLink: "",
//     affiliateContact: "",
//     revenueShare: 0,
//     commissionEarned: 0,
//     targetedCustomer: "No",
//     utmParameters: [],
//   },
//   {
//     key: "3",
//     orderId: "ORD-99283",
//     date: "2026-04-03T22:15:00",
//     creatorName: "Rohan Malhotra",
//     contact: "+91 99887 76655",
//     email: "rohan@example.com",
//     saleName: "Enterprise Upgrade",
//     coupon: "ENT20",
//     previousSetup: "Freedom",
//     previousTier: "Advanced",
//     currentSetup: "Enterprise",
//     currentTier: "Ultimate",
//     oneTimeFee: 80000,
//     subscriptionFee: 0,
//     discount: 5,
//     validity: 12,
//     paymentPlan: "One-Time",
//     status: "Paid",
//     daysLeft: 120,
//     pgCharges: 2000,
//     pgChargesGst: "incl",
//     tanNumber: "PQRS67890F",
//     gstNumber: "33MNOPQ9012R3S4",
//     noCostEmiCharges: 0,
//     affiliateName: "Priya Patel",
//     affiliateHost: "priyalearning.com",
//     affiliateLink: "https://priyalearning.com/partner",
//     affiliateContact: "+91 88776 65544",
//     revenueShare: 10,
//     commissionEarned: 8000,
//     targetedCustomer: "Yes",
//     utmParameters: [
//       { key: "utm_source", value: "facebook" },
//       { key: "utm_campaign", value: "ent" },
//     ],
//   },
//   {
//     key: "4",
//     orderId: "ORD-99284",
//     date: "2026-04-04T16:50:00",
//     creatorName: "Aishwarya Sen",
//     contact: "+91 99643 32211",
//     email: "aishwarya@example.com",
//     saleName: "Pro Launch",
//     coupon: "PROLAUNCH",
//     previousSetup: "Enterprise",
//     previousTier: "Pro",
//     currentSetup: "Enterprise",
//     currentTier: "Ultimate",
//     oneTimeFee: 120000,
//     subscriptionFee: 0,
//     discount: 10,
//     validity: 12,
//     paymentPlan: "One-Time",
//     status: "Paid",
//     daysLeft: 200,
//     pgCharges: 3000,
//     pgChargesGst: "incl",
//     tanNumber: "",
//     gstNumber: "",
//     noCostEmiCharges: 1000,
//     affiliateName: "",
//     affiliateHost: "",
//     affiliateLink: "",
//     affiliateContact: "",
//     revenueShare: 0,
//     commissionEarned: 0,
//     targetedCustomer: "No",
//     utmParameters: [],
//   },
// ];

// const dummyPriceBlockData = [
//   {
//     key: "1",
//     orderId: "PB-99283",
//     date: "2026-01-03T22:15:00",
//     name: "Rohan Malhotra",
//     contact: "+91 99887 76655",
//     email: "rohan@example.com",
//     sale: "Annual Pro Upgrade Sale",
//     amount: 80000,
//     gst: 14400,
//     status: "Open",
//     saleExpired: false,
//   },
//   {
//     key: "2",
//     orderId: "PB-99284",
//     date: "2026-04-04T16:50:00",
//     name: "Aishwarya Sen",
//     contact: "+91 99643 32211",
//     email: "aishwarya@example.com",
//     sale: "Freedom Tier 2 Migration",
//     amount: 120000,
//     gst: 21600,
//     status: "Completed",
//     saleExpired: true,
//   },
//   {
//     key: "3",
//     orderId: "PB-99285",
//     date: "2026-05-10T10:30:00",
//     name: "Priya Sharma",
//     contact: "+91 98765 43210",
//     email: "priya@example.com",
//     sale: "Enterprise Basic Launch",
//     amount: 150000,
//     gst: 27000,
//     status: "Open",
//     saleExpired: false,
//   },
// ];

const Transactions = () => {
  const [loader, setLoader] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [activeTab, setActiveTab] = useState("transactions");

  // Data states
  const [transactionsData, setTransactionsData] = useState([]);
  const [priceBlockData, setPriceBlockData] = useState([]);

  // Filter modal states
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [filterPaymentPlan, setFilterPaymentPlan] = useState([]);
  const [filterStatus, setFilterStatus] = useState([]);
  const [filterCurrentSetup, setFilterCurrentSetup] = useState([]);
  const [filterCurrentTier, setFilterCurrentTier] = useState([]);
  const [filterStartDate, setFilterStartDate] = useState(null);
  const [filterEndDate, setFilterEndDate] = useState(null);
  const [filterForm] = Form.useForm();

  // Export loading state
  const [exportLoading, setExportLoading] = useState(false);

  // Filter options for Transactions (based on API parameters)
  const paymentPlanOptions = [
    { label: "One-Time", value: "onetime" },
    { label: "Partial Pay", value: "partial" },
  ];

  const statusOptions = [
    { label: "Full Payment", value: "full_payment" },
    { label: "Partial Incomplete", value: "partial_incomplete" },
    { label: "Partial Completed", value: "partial_completed" },
    { label: "Refunded", value: "refunded" },
    { label: "Failed", value: "failed" },
  ];

  const currentSetupOptions = [
    { label: "TagMango", value: "tagmango" },
    { label: "Freedom", value: "freedom" },
    { label: "Enterprise", value: "enterprise" },
  ];

  const currentTierOptions = [
    { label: "Tier 1", value: "tier1" },
    { label: "Tier 2", value: "tier2" },
    { label: "Tier 3", value: "tier3" },
  ];

  const priceBlockStatusOptions = [
    { label: "Open", value: "open" },
    { label: "Converted", value: "converted" },
    { label: "Refunded", value: "refunded" },
    { label: "Failed", value: "failed" },
  ];

  // Helper function to map API response to table data
  const mapApiTransactionToTableRow = (transaction, index) => {
    const { creatorDetails, sale, saleItem } = transaction;

    // Map status to display value
    const statusMap = {
      full_payment: "Full Payment",
      partial_incomplete: "Partial Incomplete",
      partial_completed: "Partial Completed",
      refunded: "Refunded",
      failed: "Failed",
    };

    // Map payment plan to display value
    const paymentPlanMap = {
      onetime: "One-Time",
      partial: "Partial Pay",
    };

    // Map platform setup to display value
    const setupMap = {
      tagmango: "TagMango",
      freedom: "Freedom",
      enterprise: "Enterprise",
    };

    // Map tier to display value
    const tierMap = {
      tier1: "Tier 1",
      tier2: "Tier 2",
      tier3: "Tier 3",
    };

    // Convert customFields to UTM parameters format if applicable
    const utmParameters = transaction.customFields
      ? Object.entries(transaction.customFields)
          .map(([key, value]) => {
            if (key.toLowerCase().includes("utm_")) {
              return {
                key,
                value,
              };
            }
            return null;
          })
          .filter(Boolean)
      : [];

    return {
      key: transaction.orderId || index,
      orderId: transaction.orderId,
      date: transaction.date,
      creatorName: creatorDetails?.name || "-",
      contact: creatorDetails
        ? `${creatorDetails.dialCode || ""} ${creatorDetails.phone || ""}`
        : "-",
      email: creatorDetails?.email || "-",
      saleName: sale?.title || "-",
      saleItemTitle: saleItem?.title || "-",
      saleItemType: saleItem?.type || "-",
      features: Array.isArray(saleItem?.features) ? saleItem.features : [],
      coupon: transaction.coupon || "",
      previousSetup:
        setupMap[transaction.fanOldPlatformSetup] ||
        transaction.fanOldPlatformSetup ||
        "-",
      previousTier:
        tierMap[transaction.fanOldTier] || transaction.fanOldTier || "-",
      currentSetup:
        setupMap[transaction.fanNewPlatformSetup] ||
        transaction.fanNewPlatformSetup ||
        "-",
      currentTier:
        tierMap[transaction.fanNewTier] || transaction.fanNewTier || "-",
      oneTimeFee: transaction.onetimeFee || 0,
      subscriptionFee: transaction.subscriptionFee || 0,
      discount: transaction.discount || 0,
      validity: transaction.validityInDays
        ? Math.round(transaction.validityInDays / 30)
        : 0,
      validityInDays: transaction.validityInDays || 0,
      paymentPlan:
        paymentPlanMap[transaction.paymentPlan] ||
        transaction.paymentPlan ||
        "-",
      partialAmount: transaction.paidAmount || 0,
      status: statusMap[transaction.status] || transaction.status || "-",
      rawStatus: transaction.status,
      salePurchaseType: transaction.salePurchaseType,
      daysLeft: transaction.daysLeftToCompletePartialPayment,
      pgCharges: transaction.paymentGatewayCharges || 0,
      pgChargesGst: "incl",
      tanNumber: transaction.tanNumber || "",
      gstNumber: transaction.gstNumber || "",
      noCostEmiDiscount: transaction.noCostEmiDiscount || 0,
      affiliateName: transaction.refernEarnParent?.name || "",
      affiliateHost: transaction.refernEarnParent?.host || "",
      affiliateLink: "",
      affiliateContact: transaction.refernEarnParent?.phone || "",
      revenueShare: transaction.refernEarnParent?.revenueShare || 0,
      commissionEarned: transaction.refernEarnCommission || 0,
      targetedCustomer: "No",
      utmParameters,
      invoice: transaction.invoice || "",
      rawData: transaction,
    };
  };

  // Helper function to map Price Block API response to table data
  const mapApiPriceBlockToTableRow = (transaction, index) => {
    const { creator, sale } = transaction;

    // Map status to display value
    const statusMap = {
      open: "Open",
      converted: "Converted",
      refunded: "Refunded",
      failed: "Failed",
    };

    return {
      key: transaction.orderId || index,
      orderId: transaction.orderId,
      date: transaction.date,
      name: creator?.name || "-",
      contact: creator
        ? `${creator.dialCode || ""} ${creator.phone || ""}`
        : "-",
      email: creator?.email || "-",
      sale: sale?.title || "-",
      amount: transaction.amount || 0,
      status: statusMap[transaction.status] || transaction.status || "-",
      rawStatus: transaction.status,
      priceBlockStatus: transaction.priceBlockStatus,
      orderStatus: transaction.orderStatus,
      invoice: transaction.invoice || "",
      saleExpired: transaction.status === "converted",
      affiliateName: transaction.refernEarnParent?.name || "",
      affiliateHost: transaction.refernEarnParent?.host || "",
      affiliateLink: "",
      affiliateContact: transaction.refernEarnParent?.phone || "",
      revenueShare: transaction.refernEarnParent?.revenueShare || 0,
      rawData: transaction,
    };
  };

  // Debounce timer ref to prevent multiple API calls
  const debounceTimerRef = useRef(null);

  // Fetch transactions function wrapped in useCallback
  const fetchTransactions = useCallback(async () => {
    setLoader(true);
    try {
      if (activeTab === "transactions") {
        // Build API params
        const params = {
          page: currentPage,
          limit: pageSize,
        };

        if (searchQuery) {
          params.search = searchQuery;
        }

        if (filterPaymentPlan.length > 0) {
          params.paymentPlan = filterPaymentPlan;
        }

        if (filterStatus.length > 0) {
          params.status = filterStatus;
        }

        if (filterCurrentSetup.length > 0) {
          params.currentPlatformSetup = filterCurrentSetup;
        }

        if (filterCurrentTier.length > 0) {
          params.currentTier = filterCurrentTier;
        }

        if (filterStartDate) {
          params.startDate = filterStartDate.startOf("day").toISOString();
        }

        if (filterEndDate) {
          params.endDate = filterEndDate.endOf("day").toISOString();
        }

        const response = await fetchPlanChangeTransactions(params);

        if (response?.result?.transactions) {
          const mappedData = response.result.transactions.map(
            mapApiTransactionToTableRow
          );
          setTransactionsData(mappedData);
          setTotalItems(response.result.totalTransactions || 0);
        } else {
          setTransactionsData([]);
          setTotalItems(0);
        }
      } else {
        // Price Blocks - API call
        const params = {
          page: currentPage,
          limit: pageSize,
        };

        if (searchQuery) {
          params.search = searchQuery;
        }

        if (filterStatus.length > 0) {
          params.status = filterStatus;
        }

        if (filterStartDate) {
          params.startDate = filterStartDate.startOf("day").toISOString();
        }

        if (filterEndDate) {
          params.endDate = filterEndDate.endOf("day").toISOString();
        }

        const response = await fetchPriceBlockTransactions(params);

        if (response?.result?.transactions) {
          const mappedData = response.result.transactions.map(
            mapApiPriceBlockToTableRow
          );
          setPriceBlockData(mappedData);
          setTotalItems(response.result.totalTransactions || 0);
        } else {
          setPriceBlockData([]);
          setTotalItems(0);
        }
      }

      setLoader(false);
    } catch (error) {
      console.error("Error fetching transactions:", error);
      setLoader(false);
      message.error("Failed to fetch transactions");
    }
  }, [
    activeTab,
    currentPage,
    pageSize,
    searchQuery,
    filterPaymentPlan,
    filterStatus,
    filterCurrentSetup,
    filterCurrentTier,
    filterStartDate,
    filterEndDate,
  ]);

  // Fetch data on mount and when filters/tab changes with debounce
  useEffect(() => {
    // Clear any existing timer
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }

    // Set a new timer to debounce API calls
    debounceTimerRef.current = setTimeout(() => {
      fetchTransactions();
    }, 300);

    // Cleanup on unmount or when dependencies change
    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, [fetchTransactions]);

  // Keep the old fetchTransactions for refresh button (immediate call)
  const handleRefreshTransactions = async () => {
    setLoader(true);
    try {
      if (activeTab === "transactions") {
        const params = {
          page: currentPage,
          limit: pageSize,
        };

        if (searchQuery) {
          params.search = searchQuery;
        }

        if (filterPaymentPlan.length > 0) {
          params.paymentPlan = filterPaymentPlan;
        }

        if (filterStatus.length > 0) {
          params.status = filterStatus;
        }

        if (filterCurrentSetup.length > 0) {
          params.currentPlatformSetup = filterCurrentSetup;
        }

        if (filterCurrentTier.length > 0) {
          params.currentTier = filterCurrentTier;
        }

        if (filterStartDate) {
          params.startDate = filterStartDate.startOf("day").toISOString();
        }

        if (filterEndDate) {
          params.endDate = filterEndDate.endOf("day").toISOString();
        }

        const response = await fetchPlanChangeTransactions(params);

        if (response?.result?.transactions) {
          const mappedData = response.result.transactions.map(
            mapApiTransactionToTableRow
          );
          setTransactionsData(mappedData);
          setTotalItems(response.result.totalTransactions || 0);
        } else {
          setTransactionsData([]);
          setTotalItems(0);
        }
      } else {
        // Price Blocks - API call
        const params = {
          page: currentPage,
          limit: pageSize,
        };

        if (searchQuery) {
          params.search = searchQuery;
        }

        if (filterStatus.length > 0) {
          params.status = filterStatus;
        }

        if (filterStartDate) {
          params.startDate = filterStartDate.startOf("day").toISOString();
        }

        if (filterEndDate) {
          params.endDate = filterEndDate.endOf("day").toISOString();
        }

        const response = await fetchPriceBlockTransactions(params);

        if (response?.result?.transactions) {
          const mappedData = response.result.transactions.map(
            mapApiPriceBlockToTableRow
          );
          setPriceBlockData(mappedData);
          setTotalItems(response.result.totalTransactions || 0);
        } else {
          setPriceBlockData([]);
          setTotalItems(0);
        }
      }

      setLoader(false);
    } catch (error) {
      console.error("Error fetching transactions:", error);
      setLoader(false);
      message.error("Failed to fetch transactions");
    }
  };

  const handleRefresh = () => {
    handleRefreshTransactions();
  };

  // Export CSV handler - calls API with same filters (no pagination to export all data)
  const handleExportCsv = async () => {
    setExportLoading(true);
    try {
      let response;
      const timestamp = moment().format("YYYY-MM-DD_HH-mm");

      if (activeTab === "transactions") {
        // Build params for transactions (no pagination - export all)
        const params = {};

        if (searchQuery) {
          params.search = searchQuery;
        }

        if (filterPaymentPlan.length > 0) {
          params.paymentPlan = filterPaymentPlan;
        }

        if (filterStatus.length > 0) {
          params.status = filterStatus;
        }

        if (filterCurrentSetup.length > 0) {
          params.currentPlatformSetup = filterCurrentSetup;
        }

        if (filterCurrentTier.length > 0) {
          params.currentTier = filterCurrentTier;
        }

        if (filterStartDate) {
          params.startDate = filterStartDate.startOf("day").toISOString();
        }

        if (filterEndDate) {
          params.endDate = filterEndDate.endOf("day").toISOString();
        }

        response = await exportPlanChangeTransactionsCsv(params);

        // Create download link
        const blob = new Blob([response], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `transactions_${timestamp}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } else {
        // Build params for price blocks (no pagination - export all)
        const params = {};

        if (searchQuery) {
          params.search = searchQuery;
        }

        if (filterStatus.length > 0) {
          params.status = filterStatus;
        }

        if (filterStartDate) {
          params.startDate = filterStartDate.startOf("day").toISOString();
        }

        if (filterEndDate) {
          params.endDate = filterEndDate.endOf("day").toISOString();
        }

        response = await exportPriceBlockTransactionsCsv(params);

        // Create download link
        const blob = new Blob([response], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `price_blocks_${timestamp}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }

      message.success("CSV exported successfully!");
    } catch (error) {
      console.error("Error exporting CSV:", error);
      message.error("Failed to export CSV");
    } finally {
      setExportLoading(false);
    }
  };

  const getTransactionActionMenuItems = (record) => {
    const items = [];

    if (record.invoice) {
      items.push({
        key: "invoice",
        label: "Download Invoice",
        icon: <DownloadOutlined style={{ color: "#3b82f6" }} />,
        onClick: () => {
          window.open(record.invoice, "_blank");
        },
      });
    }

    return items;
  };

  const getPriceBlockActionMenuItems = (record) => {
    const items = [];

    const canDownloadInvoice =
      record.invoice &&
      (record.rawStatus === "open" ||
        record.rawStatus === "converted" ||
        record.rawStatus === "refunded");

    if (canDownloadInvoice) {
      items.push({
        key: "invoice",
        label: "Download Invoice",
        icon: <DownloadOutlined style={{ color: "#3b82f6" }} />,
        onClick: () => {
          window.open(record.invoice, "_blank");
        },
      });
    }

    return items;
  };

  // Filter modal handlers
  const handleOpenFilterModal = () => {
    filterForm.setFieldsValue({
      paymentPlan: filterPaymentPlan,
      status: filterStatus,
      currentSetup: filterCurrentSetup,
      currentTier: filterCurrentTier,
      dateRange:
        filterStartDate || filterEndDate
          ? [filterStartDate, filterEndDate]
          : undefined,
    });
    setIsFilterModalOpen(true);
  };

  const handleFilterModalCancel = () => {
    setIsFilterModalOpen(false);
  };

  const handleApplyFilters = (values) => {
    setCurrentPage(1);
    setFilterPaymentPlan(values.paymentPlan || []);
    setFilterStatus(values.status || []);
    setFilterCurrentSetup(values.currentSetup || []);
    setFilterCurrentTier(values.currentTier || []);
    setFilterStartDate(values.dateRange?.[0] || null);
    setFilterEndDate(values.dateRange?.[1] || null);
    setIsFilterModalOpen(false);
  };

  const handleClearFilters = () => {
    setCurrentPage(1);
    setFilterPaymentPlan([]);
    setFilterStatus([]);
    setFilterCurrentSetup([]);
    setFilterCurrentTier([]);
    setFilterStartDate(null);
    setFilterEndDate(null);
    filterForm.resetFields();
    setIsFilterModalOpen(false);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const activeFilterCount =
    filterPaymentPlan.length +
    filterStatus.length +
    filterCurrentSetup.length +
    filterCurrentTier.length +
    (filterStartDate || filterEndDate ? 1 : 0);

  // Calculate days left in real-time
  const calculateDaysLeft = (daysLeft) => {
    if (daysLeft <= 0) return <Text>-</Text>;
    if (daysLeft <= 7)
      return (
        <Tag color="warning">
          {daysLeft} day{daysLeft > 1 ? "s" : ""}
        </Tag>
      );
    return (
      <Tag color="success">
        {daysLeft} day{daysLeft > 1 ? "s" : ""}
      </Tag>
    );
  };

  // Transactions table columns
  const transactionsColumns = [
    {
      title: "ORDER ID",
      dataIndex: "orderId",
      key: "orderId",
      width: 120,
      render: (text) => (
        <Typography.Text style={{ fontWeight: 500 }}>{text}</Typography.Text>
      ),
    },
    {
      title: "DATE",
      dataIndex: "date",
      key: "date",
      width: 170,
      render: (text) => (
        <Typography.Text style={{ fontSize: 12 }}>
          {moment(text).format("DD MMM YYYY, hh:mm A")}
        </Typography.Text>
      ),
    },
    {
      title: "CREATOR NAME",
      dataIndex: "creatorName",
      key: "creatorName",
      width: 150,
      render: (text) => (
        <Typography.Text style={{ fontWeight: 500 }}>{text}</Typography.Text>
      ),
    },
    {
      title: "CONTACT",
      dataIndex: "contact",
      key: "contact",
      width: 280,
      render: (text, record) => (
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
            <Typography.Text>{text}</Typography.Text>
            {text && text !== "-" && (
              <Tooltip title="Copy Phone">
                <CopyOutlined
                  style={{ color: "#9ca3af", cursor: "pointer", fontSize: 12 }}
                  onClick={() => {
                    if (!text || text === "-") return;
                    navigator.clipboard.writeText(
                      text?.split(" ")?.[1]?.trim()
                    );
                    message.success("Phone copied!");
                  }}
                />
              </Tooltip>
            )}
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
            <Typography.Text type="secondary" style={{ fontSize: 12 }}>
              {record.email}
            </Typography.Text>
            {record.email && record.email !== "-" && (
              <Tooltip title="Copy Email">
                <CopyOutlined
                  style={{ color: "#9ca3af", cursor: "pointer", fontSize: 12 }}
                  onClick={() => {
                    navigator.clipboard.writeText(record.email);
                    message.success("Email copied!");
                  }}
                />
              </Tooltip>
            )}
          </div>
        </div>
      ),
    },
    {
      title: "TYPE",
      dataIndex: "salePurchaseType",
      key: "salePurchaseType",
      width: 120,
      render: (type) =>
        type === "plan_change" ? (
          <Tag
            color="green"
            bordered={false}
            style={{ width: "100%", textAlign: "center" }}
          >
            SALE
          </Tag>
        ) : (
          <Tag
            color="blue"
            bordered={false}
            style={{ width: "100%", textAlign: "center" }}
          >
            ONE TO ONE
          </Tag>
        ),
    },

    {
      title: "SALES NAME",
      dataIndex: "saleName",
      key: "saleName",
      width: 150,
      render: (text) => (
        <Typography.Text style={{ fontWeight: 500 }}>{text}</Typography.Text>
      ),
    },

    {
      title: "FEATURES",
      dataIndex: "features",
      key: "features",
      width: 140,
      render: (features) => (
        <Typography.Text>
          {features?.length ? features.join(", ") : "-"}
        </Typography.Text>
      ),
    },

    {
      title: "COUPON",
      dataIndex: "coupon",
      key: "coupon",
      width: 150,
      render: (text) =>
        text ? (
          <Space>
            <Tag color="purple" bordered={false}>
              {text}
            </Tag>
            {/* <Tooltip title="Copy Coupon">
              <Button
                type="text"
                size="small"
                icon={<CopyOutlined />}
                onClick={() => {
                  navigator.clipboard.writeText(text);
                  message.success("Coupon copied!");
                }}
              />
            </Tooltip> */}
          </Space>
        ) : (
          "-"
        ),
    },
    {
      title: <span style={{ whiteSpace: "nowrap" }}>PREVIOUS SETUP</span>,
      dataIndex: "previousSetup",
      key: "previousSetup",
      width: 150,
    },
    {
      title: <span style={{ whiteSpace: "nowrap" }}>PREVIOUS TIER</span>,
      dataIndex: "previousTier",
      key: "previousTier",
      width: 150,
    },
    {
      title: <span style={{ whiteSpace: "nowrap" }}>CURRENT SETUP</span>,
      dataIndex: "currentSetup",
      key: "currentSetup",
      width: 130,
      render: (text) => (
        <Typography.Text style={{ fontWeight: 500 }}>{text}</Typography.Text>
      ),
    },
    {
      title: <span style={{ whiteSpace: "nowrap" }}>CURRENT TIER</span>,
      dataIndex: "currentTier",
      key: "currentTier",
      width: 120,
      render: (text) => (
        <Typography.Text style={{ fontWeight: 500 }}>{text}</Typography.Text>
      ),
    },
    {
      title: <span style={{ whiteSpace: "nowrap" }}>ONE TIME FEE</span>,
      dataIndex: "oneTimeFee",
      key: "oneTimeFee",
      width: 130,
      render: (text) => (
        <Typography.Text style={{ fontWeight: 500 }}>
          ₹{text?.toLocaleString("en-IN") || 0}
        </Typography.Text>
      ),
    },
    {
      title: <span style={{ whiteSpace: "nowrap" }}>SUBSCRIPTION FEE</span>,
      dataIndex: "subscriptionFee",
      key: "subscriptionFee",
      width: 160,
      render: (text) => (
        <Typography.Text>₹{text?.toLocaleString("en-IN") || 0}</Typography.Text>
      ),
    },
    {
      title: "DISCOUNT",
      dataIndex: "discount",
      key: "discount",
      width: 110,
      render: (text, record) => (
        <Typography.Text style={{ color: "#ef4444", fontWeight: 500 }}>
          {!!record.coupon && text ? `-${text}%` : "-"}
        </Typography.Text>
      ),
    },
    {
      title: "VALIDITY",
      dataIndex: "validityInDays",
      key: "validityInDays",
      width: 120,
      render: (text) => (text ? `${text} Day${text > 1 ? "s" : ""}` : "-"),
    },
    {
      title: <span style={{ whiteSpace: "nowrap" }}>PAYMENT PLAN</span>,
      dataIndex: "paymentPlan",
      key: "paymentPlan",
      width: 130,
      render: (text) => {
        const color = text === "One-Time" ? "blue" : "orange";
        return (
          <Tag color={color} bordered={false}>
            {text}
          </Tag>
        );
      },
    },
    {
      title: (
        <Space>
          <span style={{ whiteSpace: "nowrap" }}>PAID AMOUNT</span>
          <Tooltip title="Include GST & after TDS (if applicable)">
            <InfoCircleOutlined style={{ color: "#9ca3af" }} />
          </Tooltip>
        </Space>
      ),
      dataIndex: "partialAmount",
      key: "partialAmount",
      width: 160,
      render: (text) => (
        // dispaly a tooltip with i icon
        <>
          <Typography.Text>
            ₹{text?.toLocaleString("en-IN") || 0}
          </Typography.Text>
        </>
      ),
    },
    {
      title: "STATUS",
      dataIndex: "status",
      key: "status",
      width: 150,
      render: (status) => {
        const colorMap = {
          "Full Payment": "success",
          "Partial Completed": "success",
          "Partial Incomplete": "warning",
          Refunded: "error",
          Failed: "error",
        };
        const color = colorMap[status] || "default";
        return (
          <Tag color={color} bordered={false}>
            {status}
          </Tag>
        );
      },
    },
    {
      title: <span style={{ whiteSpace: "nowrap" }}>DAYS LEFT</span>,
      dataIndex: "daysLeft",
      key: "daysLeft",
      width: 100,
      render: (days) => calculateDaysLeft(days),
    },
    {
      title: (
        <Space>
          <span style={{ whiteSpace: "nowrap" }}>PG CHARGES</span>
          <Tooltip title="Payment Gateway Charges">
            <InfoCircleOutlined style={{ color: "#9ca3af" }} />
          </Tooltip>
        </Space>
      ),
      dataIndex: "pgCharges",
      key: "pgCharges",
      width: 140,
      render: (text) => (
        <Typography.Text>
          ₹{text?.toLocaleString("en-IN") || 0}
          {/* <br />
          <Text type="secondary" style={{ fontSize: 10 }}>
            ({record.pgChargesGst === "incl" ? "incl. GST" : "excl. GST"})
          </Text> */}
        </Typography.Text>
      ),
    },
    {
      title: "TAN NUMBER",
      dataIndex: "tanNumber",
      key: "tanNumber",
      width: 130,
      render: (text) => text || "-",
    },
    {
      title: "GST NUMBER",
      dataIndex: "gstNumber",
      key: "gstNumber",
      width: 160,
      render: (text) => text || "-",
    },
    {
      title: <span style={{ whiteSpace: "nowrap" }}>NO COST EMI</span>,
      dataIndex: "noCostEmiDiscount",
      key: "noCostEmiDiscount",
      width: 120,
      render: (text) =>
        text ? `₹${text?.toFixed(2)?.toLocaleString("en-IN")}` : "-",
    },
    {
      title: "AFFILIATE NAME",
      dataIndex: "affiliateName",
      key: "affiliateName",
      width: 140,
      render: (text) => text || "-",
    },
    {
      title: "AFFILIATE HOST",
      dataIndex: "affiliateHost",
      key: "affiliateHost",
      width: 180,
      render: (text) =>
        text ? (
          <Typography.Link href={`https://${text}`} target="_blank">
            {text}
          </Typography.Link>
        ) : (
          "-"
        ),
    },
    // {
    //   title: (
    //     <Space>
    //       TARGETED
    //       <Tooltip title="Customers who purchased the product but were not selected under 'User Type'">
    //         <InfoCircleOutlined style={{ color: "#9ca3af" }} />
    //       </Tooltip>
    //     </Space>
    //   ),
    //   dataIndex: "targetedCustomer",
    //   key: "targetedCustomer",
    //   width: 110,
    //   render: (text) => (
    //     <Tag color={text === "Yes" ? "green" : "default"} bordered={false}>
    //       {text}
    //     </Tag>
    //   ),
    // },
    {
      title: "UTM  Parameters",
      dataIndex: "utmParameters",
      key: "utmParameters",
      width: 200,
      render: (params) =>
        params && params.length > 0 ? (
          <Tooltip
            title={
              <ul style={{ margin: 0, paddingLeft: 16 }}>
                {params.map((param) => (
                  <li key={`${param.key}`}>
                    <strong>{param.key}:</strong> {param.value}
                  </li>
                ))}
              </ul>
            }
          >
            <ul
              style={{
                margin: 0,
                paddingLeft: 16,
                fontSize: 12,
                maxHeight: 60,
                overflow: "hidden",
              }}
            >
              {params.slice(0, 2).map((param) => (
                <li key={`${param.key}`}>
                  <Text type="secondary" style={{ fontSize: 11 }}>
                    {param.key}:
                  </Text>{" "}
                  <Text style={{ fontSize: 11 }}>{param.value}</Text>
                </li>
              ))}
              {params.length > 2 && (
                <li>
                  <Text type="secondary" style={{ fontSize: 11 }}>
                    +{params.length - 2} more...
                  </Text>
                </li>
              )}
            </ul>
          </Tooltip>
        ) : (
          "-"
        ),
    },
    {
      title: "ACTION",
      dataIndex: "action",
      key: "action",
      width: 100,
      fixed: "right",
      render: (_, record) => (
        <Dropdown
          menu={{ items: getTransactionActionMenuItems(record) }}
          trigger={["click"]}
          placement="bottomRight"
          disabled={getTransactionActionMenuItems(record).length === 0}
        >
          <Button
            type="text"
            icon={<MoreOutlined style={{ fontSize: 20 }} />}
            onClick={(e) => e.preventDefault()}
          />
        </Dropdown>
      ),
    },
  ];

  // Price Block table columns
  const priceBlockColumns = [
    {
      title: "ORDER ID",
      dataIndex: "orderId",
      key: "orderId",
      width: 120,
      render: (text) => (
        <Typography.Text style={{ fontWeight: 500 }}>{text}</Typography.Text>
      ),
    },
    {
      title: "DATE",
      dataIndex: "date",
      key: "date",
      width: 180,
      render: (text) => (
        <Typography.Text>
          {moment(text).format("DD MMM YYYY, hh:mm A")}
        </Typography.Text>
      ),
    },
    {
      title: "NAME",
      dataIndex: "name",
      key: "name",
      width: 180,
      render: (text) => (
        <Typography.Text style={{ fontWeight: 500 }}>{text}</Typography.Text>
      ),
    },
    {
      title: "CONTACT",
      dataIndex: "contact",
      key: "contact",
      width: 280,
      render: (text, record) => (
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
            <Typography.Text>{text}</Typography.Text>
            {text && text !== "-" && (
              <Tooltip title="Copy Phone">
                <CopyOutlined
                  style={{ color: "#9ca3af", cursor: "pointer", fontSize: 12 }}
                  onClick={() => {
                    if (!text || text === "-") return;
                    navigator.clipboard.writeText(
                      text?.split(" ")?.[1]?.trim()
                    );
                    message.success("Phone copied!");
                  }}
                />
              </Tooltip>
            )}
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
            <Typography.Text type="secondary" style={{ fontSize: 12 }}>
              {record.email}
            </Typography.Text>
            {record.email && record.email !== "-" && (
              <Tooltip title="Copy Email">
                <CopyOutlined
                  style={{ color: "#9ca3af", cursor: "pointer", fontSize: 12 }}
                  onClick={() => {
                    navigator.clipboard.writeText(record.email);
                    message.success("Email copied!");
                  }}
                />
              </Tooltip>
            )}
          </div>
        </div>
      ),
    },
    {
      title: "SALE",
      dataIndex: "sale",
      key: "sale",
      width: 180,
      render: (text) => (
        <Typography.Text style={{ fontWeight: 500 }}>
          {text || "-"}
        </Typography.Text>
      ),
    },
    {
      title: "AMOUNT",
      dataIndex: "amount",
      key: "amount",
      width: 130,
      render: (text) => (
        <Typography.Text style={{ color: "#7c3aed", fontWeight: 600 }}>
          ₹{text?.toLocaleString("en-IN") || 0}
        </Typography.Text>
      ),
    },
    {
      title: "AFFILIATE NAME",
      dataIndex: "affiliateName",
      key: "affiliateName",
      width: 140,
      render: (text) => text || "-",
    },
    {
      title: "AFFILIATE HOST",
      dataIndex: "affiliateHost",
      key: "affiliateHost",
      width: 180,
      render: (text) =>
        text ? (
          <Typography.Link href={`https://${text}`} target="_blank">
            {text}
          </Typography.Link>
        ) : (
          "-"
        ),
    },
    {
      title: "STATUS",
      dataIndex: "status",
      key: "status",
      width: 130,
      render: (status) => {
        const colorMap = {
          Open: "processing",
          Converted: "success",
          Refunded: "error",
          Failed: "error",
        };
        const color = colorMap[status] || "default";
        return (
          <Tag color={color} bordered={false}>
            {status}
          </Tag>
        );
      },
    },
    {
      title: "ACTION",
      dataIndex: "action",
      key: "action",
      width: 100,
      fixed: "right",
      render: (_, record) => {
        const menuItems = getPriceBlockActionMenuItems(record);
        return (
          <Dropdown
            menu={{ items: menuItems }}
            trigger={["click"]}
            placement="bottomRight"
            disabled={menuItems.length === 0}
          >
            <Button
              type="text"
              icon={<MoreOutlined style={{ fontSize: 20 }} />}
              onClick={(e) => e.preventDefault()}
            />
          </Dropdown>
        );
      },
    },
  ];

  const tabItems = [
    {
      key: "transactions",
      label: "Transactions",
      children: (
        <div
          style={{
            background: "#fff",
            padding: "14px",
            borderRadius: 8,
            boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
          }}
        >
          <Table
            columns={transactionsColumns}
            dataSource={transactionsData}
            loading={loader}
            pagination={{
              current: currentPage,
              pageSize,
              total: totalItems,
              onChange: handlePageChange,
              showSizeChanger: false,
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} transactions`,
            }}
            locale={{
              emptyText: "No transactions found",
            }}
            scroll={{ x: 3200 }}
            rowKey="key"
          />
        </div>
      ),
    },
    {
      key: "priceBlock",
      label: "Price Blocks",
      children: (
        <div
          style={{
            background: "#fff",
            padding: "14px",
            borderRadius: 8,
            boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
          }}
        >
          <Table
            columns={priceBlockColumns}
            dataSource={priceBlockData}
            loading={loader}
            pagination={{
              current: currentPage,
              pageSize,
              total: totalItems,
              onChange: handlePageChange,
              showSizeChanger: false,
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} price blocks`,
            }}
            locale={{
              emptyText: "No price block transactions found",
            }}
            scroll={{ x: 1400 }}
            rowKey="key"
          />
        </div>
      ),
    },
  ];

  return (
    <>
      <FiltersWrapper style={{ justifyContent: "space-between" }}>
        <div
          style={{
            display: "flex",
            gap: 10,
            width: "50%",
          }}
        >
          <CustomSearchbar
            placeholder="Search by Order ID, Creator, Email or Phone..."
            searchQuery={searchQuery}
            setSearchQuery={(value) => {
              setCurrentPage(1);
              setSearchQuery(value);
            }}
            style={{ marginBottom: 0, maxWidth: 400 }}
          />

          <Tooltip title="Refresh">
            <Button size="large" onClick={handleRefresh}>
              <ReloadOutlined />
            </Button>
          </Tooltip>
        </div>

        <div style={{ display: "flex", gap: 10 }}>
          <Tooltip title="Filter">
            <Button
              size="large"
              onClick={handleOpenFilterModal}
              style={{ position: "relative" }}
            >
              <FilterOutlined />
              {activeFilterCount > 0 && (
                <span
                  style={{
                    position: "absolute",
                    top: -6,
                    right: -6,
                    background: "#7c3aed",
                    color: "#fff",
                    borderRadius: "50%",
                    width: 18,
                    height: 18,
                    fontSize: 11,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: 600,
                  }}
                >
                  {activeFilterCount}
                </span>
              )}
            </Button>
          </Tooltip>

          <Button
            className="siteBtn grayBtn"
            onClick={handleExportCsv}
            loading={exportLoading}
          >
            <DownloadOutlined />
            Export CSV
          </Button>
        </div>
      </FiltersWrapper>

      <div style={{ marginTop: 24 }}>
        <Tabs
          activeKey={activeTab}
          onChange={(key) => {
            setActiveTab(key);
            setCurrentPage(1);
            // Clear filters when switching tabs since they have different options
            setFilterPaymentPlan([]);
            setFilterStatus([]);
            setFilterCurrentSetup([]);
            setFilterCurrentTier([]);
            setFilterStartDate(null);
            setFilterEndDate(null);
            filterForm.resetFields();
          }}
          items={tabItems}
        />
      </div>
      {/* Filter Modal */}
      <Modal
        title={
          activeTab === "transactions"
            ? "Filter Transactions"
            : "Filter Price Blocks"
        }
        open={isFilterModalOpen}
        onCancel={handleFilterModalCancel}
        footer={null}
        width={450}
        destroyOnClose
        centered
      >
        <Form
          form={filterForm}
          layout="vertical"
          onFinish={handleApplyFilters}
          style={{ marginTop: 0 }}
        >
          {activeTab === "transactions" && (
            <>
              <Form.Item
                label={
                  <span style={{ fontWeight: 600, color: "#6b7280" }}>
                    PAYMENT PLAN
                  </span>
                }
                name="paymentPlan"
                style={{ marginBottom: 24 }}
              >
                <Select
                  mode="multiple"
                  size="large"
                  placeholder="Select Payment Plan"
                  style={{ width: "100%", borderRadius: 8 }}
                  allowClear
                  suffixIcon={<DownOutlined style={{ color: "#9ca3af" }} />}
                  options={paymentPlanOptions}
                  showArrow
                />
              </Form.Item>

              <Form.Item
                label={
                  <span style={{ fontWeight: 600, color: "#6b7280" }}>
                    CURRENT SETUP
                  </span>
                }
                name="currentSetup"
                style={{ marginBottom: 24 }}
              >
                <Select
                  mode="multiple"
                  size="large"
                  placeholder="Select Current Setup"
                  style={{ width: "100%", borderRadius: 8 }}
                  allowClear
                  suffixIcon={<DownOutlined style={{ color: "#9ca3af" }} />}
                  options={currentSetupOptions}
                  showArrow
                />
              </Form.Item>

              <Form.Item
                label={
                  <span style={{ fontWeight: 600, color: "#6b7280" }}>
                    CURRENT TIER
                  </span>
                }
                name="currentTier"
                style={{ marginBottom: 24 }}
              >
                <Select
                  mode="multiple"
                  size="large"
                  placeholder="Select Current Tier"
                  style={{ width: "100%", borderRadius: 8 }}
                  allowClear
                  suffixIcon={<DownOutlined style={{ color: "#9ca3af" }} />}
                  options={currentTierOptions}
                  showArrow
                />
              </Form.Item>
            </>
          )}

          <Form.Item
            label={
              <span style={{ fontWeight: 600, color: "#6b7280" }}>
                DATE RANGE
              </span>
            }
            name="dateRange"
            style={{ marginBottom: 24 }}
          >
            <DatePicker.RangePicker
              size="large"
              style={{ width: "100%", borderRadius: 8 }}
              format="DD MMM YYYY"
              allowClear
              disabledDate={(current) =>
                current && current > moment().endOf("day")
              }
            />
          </Form.Item>

          <Form.Item
            label={
              <span style={{ fontWeight: 600, color: "#6b7280" }}>STATUS</span>
            }
            name="status"
            style={{ marginBottom: 24 }}
          >
            <Select
              mode="multiple"
              size="large"
              placeholder="Select Status"
              style={{ width: "100%", borderRadius: 8 }}
              allowClear
              suffixIcon={<DownOutlined style={{ color: "#9ca3af" }} />}
              options={
                activeTab === "transactions"
                  ? statusOptions
                  : priceBlockStatusOptions
              }
              showArrow
            />
          </Form.Item>

          <Form.Item style={{ marginBottom: 0, marginTop: 32 }}>
            <Space style={{ width: "100%", justifyContent: "flex-end" }}>
              <Button
                size="large"
                onClick={handleClearFilters}
                style={{
                  borderRadius: 8,
                  minWidth: 120,
                }}
              >
                Clear All
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                style={{
                  background: "#7c3aed",
                  borderColor: "#7c3aed",
                  borderRadius: 8,
                  minWidth: 120,
                }}
              >
                Apply Filters
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default Transactions;
